import { Authentication, ObjectType } from '@/constants/DoITConstant'
import http from '../plugins/http'
import axios from 'axios'
import { PASSWORD, USER_AUTH, USER_INFO, USER_PROFILE } from '@/config/config_api_backend'
import {
  getLocalStorage,
  putLocalStorage,
  putLocalStorageObject,
  removeLocalStorage,
} from '@/helpers/LocalStorageHelper'
import { Paths } from '@/routes/paths.js'

const isAuthenticated = () => {
  return getLocalStorage(Authentication.USER_INFO) != null
}

const logout = async () => {
  await logoutWithoutRedirect()
  if (![Paths.LOGIN,
    Paths.REGISTER,
    Paths.REGISTRATION_RESEND_ACTIVATION,
    Paths.REGISTRATION_CONFIRM_ACTIVATION,
    Paths.PASSWORD_FORGOT,
    Paths.PASSWORD_RESET
  ].includes(location.pathname)) {
    location.href = Paths.LOGIN
  }
}

const logoutWithoutRedirect = async () => {
  await axios.post(USER_AUTH.LOGOUT, {})

  window.gAuth.signOut().catch((error) => {
    console.error(error)
  })
  removeLocalStorage(Authentication.ACCESS_TOKEN_KEY)
  removeLocalStorage(Authentication.REFRESH_TOKEN_KEY)
  removeLocalStorage(Authentication.TAG_PERMISSION)
  removeLocalStorage(Authentication.DOCUMENT_PERMISSION)
  removeLocalStorage(Authentication.USER_INFO)
}

const HEADER_BASE_AUTHENTICATION = process.env.VUE_APP_HEADER_BASE_AUTHENTICATION === 'TRUE'

const login = async (username, password) => {
  try {
    let response = await axios.post(USER_AUTH.LOGIN, {
      username,
      password,
    })
    console.log(HEADER_BASE_AUTHENTICATION)
    if (response.status === 200) {
      await onLoginSuccess(response)
    } else {
      throw 'Có lỗi xảy ra trong quá trình đăng nhập'
    }
  } catch (error) {
    console.log(error)
    if (error.hasOwnProperty('response') && error.response.status === 400) {
      if (error.response.data.error_description === 'User is disabled') {
        throw 'Tài khoản chưa kích hoạt, vui lòng kiểm tra email'
      } else {
        throw 'Tên đăng nhập hoặc mật khẩu không đúng'
      }
    } else {
      throw 'Có lỗi xảy ra trong quá trình đăng nhập'
    }
  }
}

const verifyToken = async (token, onSuccess, onError, onComplete) => {
  try {
    let response = await axios.post(USER_AUTH.GOOGLE_VERIFY_TOKEN, token)
    if (response.status === 200) {
      onLoginSuccess(response, onSuccess)
    } else {
      onError('Có lỗi xảy ra trong quá trình đăng nhập')
    }
  } catch (error) {
    onError('Có lỗi xảy ra trong quá trình đăng nhập')
  } finally {
    onComplete()
  }
}

const onLoginSuccess = (response) => {
  if (HEADER_BASE_AUTHENTICATION) {
    console.log(response.headers)
    putLocalStorage(Authentication.ACCESS_TOKEN_KEY, response.headers[Authentication.ACCESS_TOKEN_HEADER])
    putLocalStorage(Authentication.REFRESH_TOKEN_KEY, response.headers[Authentication.REFRESH_TOKEN_HEADER])
  }
}

const register = async (name, email, password, confirmPassword, onSuccess, onError, onComplete) => {
  const encoded = btoa(`${Authentication.CLIENT_ID}:${Authentication.CLIENT_SECRET}`)
  const formData = new FormData()
  formData.append('client_id', Authentication.CLIENT_ID)
  formData.append('email', email)
  formData.append('password', password)
  formData.append('confirmPassword', confirmPassword)
  formData.append('name', name)
  try {
    let response = await axios.post(USER_AUTH.REGISTER, formData, {
      headers: {
        Authorization: 'Basic ' + encoded,
      },
    })
    if (response.status === 200 && response.data.status === 'SUCCESS') {
      onSuccess()
    } else {
      onError(response.data.description)
    }
  } catch (error) {
    if ('response' in error) {
      onError(error.response.data.description)
    } else {
      onError('Có lỗi xảy ra trong quá trình đăng ký')
    }
  } finally {
    onComplete()
  }
}
const changePassword = async (oldPassword, password, confirmPassword, onSuccess, onError, onComplete) => {
  const formData = new FormData()
  formData.append('oldPassword', oldPassword)
  formData.append('password', password)
  formData.append('confirmPassword', confirmPassword)
  try {
    let response = await http.post(PASSWORD.CHANGE, formData)
    if (response.status === 200 && response.data.status === 'SUCCESS') {
      onSuccess()
    } else {
      onError(response.data.description)
    }
  } catch (error) {
    if ('response' in error) {
      onError(error.response.data.description)
    } else {
      onError('Có lỗi xảy ra')
    }
  } finally {
    onComplete()
  }
}

const resetPasswordByAdmin = async (email, password) => {
  const formData = new FormData()
  formData.append('email', email)
  formData.append('password', password)
  let response = await http.post(PASSWORD.ADMIN_RESET, formData)
  if (response.status === 200 && response.data.status === 'SUCCESS') {
    onError(response.data.description)
  }
  return response.data
}
const forgotPassword = async (email, onSuccess, onError, onComplete) => {
  try {
    const formData = new FormData()
    formData.append('email', email)
    formData.append('recaptchaToken', null)
    let response = await http.post(PASSWORD.FORGOT, formData)
    if (response.status === 200 && response.data.status === 'SUCCESS') {
      onSuccess()
    } else {
      onError(response.data.description)
    }
  } catch (error) {
    if ('response' in error) {
      onError(error.response.data.description)
    } else {
      onError('Có lỗi xảy ra')
    }
  } finally {
    onComplete()
  }
}

const confirmRegistration = async (token, onSuccess, onError, onComplete) => {
  try {
    let response = await axios.get(USER_AUTH.CONFIRM_REGISTRATION, {
      params: {
        token: token,
      },
    })
    if (response.status === 200 && response.data.status === 'SUCCESS') {
      onSuccess()
    } else {
      onError(response.data.description)
    }
  } catch (error) {
    if ('response' in error) {
      onError(error.response.data.description)
    } else {
      onError('Có lỗi xảy ra')
    }
  } finally {
    onComplete()
  }
}

const resendConfirmRegistration = async (email, onSuccess, onError, onComplete) => {
  try {
    let response = await axios.get(USER_AUTH.RESEND_CONFIRM_REGISTRATION, {
      params: {
        email: email,
      },
    })
    if (response.status === 200 && response.data.status === 'SUCCESS') {
      onSuccess()
    } else {
      onError(response.data.description)
    }
  } catch (error) {
    if ('response' in error) {
      onError(error.response.data.description)
    } else {
      onError('Có lỗi xảy ra')
    }
  } finally {
    onComplete()
  }
}

const resetPassword = async (token, password, confirmPassword, onSuccess, onError, onComplete) => {
  const encoded = btoa(`${Authentication.CLIENT_ID}:${Authentication.CLIENT_SECRET}`)
  const formData = new FormData()
  formData.append('token', token)
  formData.append('password', password)
  formData.append('confirmPassword', confirmPassword)
  try {
    let response = await axios.post(PASSWORD.RESET, formData, {
      headers: {
        Authorization: 'Basic ' + encoded,
      },
    })

    if (response.status === 200 && response.data.status === 'SUCCESS') {
      onSuccess()
    } else {
      onError(response.data.description)
    }
  } catch (error) {
    if ('response' in error) {
      onError(error.response.data.description)
    } else {
      onError('Có lỗi xảy ra')
    }
  } finally {
    onComplete()
  }
}

const updateGlobalUserPermission = async () => {
  let docPermission = getUserPermission(null, ObjectType.DOCUMENT)
  let tagPermission = getUserPermission(null, ObjectType.Tag)
  putLocalStorageObject(Authentication.DOCUMENT_PERMISSION, await docPermission)
  putLocalStorageObject(Authentication.TAG_PERMISSION, await tagPermission)
  return null
}

const updateUserInfo = async () => {
  let userInfo = (await http.get(USER_INFO.GET_INFO)).data
  putLocalStorageObject(Authentication.USER_INFO, userInfo)
  return null
}

const getUserInfo = async () => {
  return (await http.get(USER_INFO.GET_INFO)).data
}

export const getRecentCreditUsage = async () => {
  return (await http.get(USER_INFO.GET_RECENT_CREDIT_USAGE)).data
}

const getUserPermission = async (objectId, objectType) => {
  return (
    await http.get(USER_INFO.GET_PERMISSION, {
      params: {
        objectId: objectId,
        objectType: objectType,
      },
    })
  ).data.permission
}

const getUserProfile = async (onError) => {
  try {
    let response = await http.get(USER_PROFILE.GET)
    if (response.status === 200) {
      return response.data
    } else {
      onError(response.data.description)
      return null
    }
  } catch (e) {
    onError('Có lỗi xảy ra')
    return null
  }
}

const getEmailExistenceInfo = async (email) => {
  try {
    const formData = new FormData()
    formData.append('email', email)

    let response = await http.post(USER_AUTH.CHECK_EMAIL_EXISTENCE, formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response.data
  } catch (e) {
    console.log(e)
    return null
  }
}

export {
  isAuthenticated,
  logout,
  logoutWithoutRedirect,
  login,
  getUserPermission,
  getUserProfile,
  register,
  forgotPassword,
  resetPassword,
  changePassword,
  confirmRegistration,
  resendConfirmRegistration,
  getEmailExistenceInfo,
  resetPasswordByAdmin,
  verifyToken,
  getUserInfo,
}
